var Swiper = require('swiper').default;

var Experts = {
  init: function () {
    var expertsContainer = document.querySelector('.slot-experts-posts .swiper-container');

    new Swiper(expertsContainer, {
      slidesPerView: 5,
      spaceBetween: 10,
      // initialSlide: expertsContainer.querySelectorAll('.swiper-slide').length / 2,
      loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      slideToClickedSlide: true,
      freeMode: true,
      freeModeSticky: true,
      slidesPerColumnFill: 'row',
      freeModeMomentumRatio: 1,
      freeModeMomentumVelocityRatio: 0.5,
      on: {
        init: Experts.slideChange,
        slideChange: Experts.slideChange
      }
    });
  },

  slideChange: function () {
    var activeSlide = this.slides[this.activeIndex];
    var data = $(activeSlide).data() || {};

    if (activeSlide && data.expertNicename) {
      Experts.blogExpertsPosts(data);
    }
  },

  blogExpertsPosts: function (data) {
    var html =
      '<div class="lazyload" data-include="/api/htmls/blog/expertsPosts?size=4&niceName=' +
      data.expertNicename +
      '"></div>';
    $('.experts-posts-description').html(data.expertDescription);
    $('.experts-posts-list').html(html);
  }
};

module.exports = Experts;
